export default __webpack_public_path__ + "images/8F.f8c16b9.png";